import { LoadingSpinner } from '@web_opxp/components';
import { LanguageSelectors } from '@web_opxp/features';
import * as React from 'react';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import { AppSelectors } from '../app';
import ENV from '../base/env';
import { IState } from '../store/state';
import { EExerciseView } from './constants';
import './Exercise.scss';
import CelebrationPage from './pages/CelebrationPage';
import ChallengeExerciseCompletedPage from './pages/ChallengeExerciseCompletedPage';
import EvaluationPage from './pages/EvaluationPage';
import ExtraModesPage from './pages/ExtraModesPage';
import IntroPage from './pages/IntroPage';
import NotImplementedModePage from './pages/NotImplementedModePage';
import PostFirstSessionPage from './pages/PostFirstSessionPage';
import SessionPage from './pages/SessionPage';
import WorkoutPage from './pages/WorkoutPage';
import * as Selectors from './selectors';
import { ExerciseActions } from './slice';
import { handlePathChange } from './utils';
import { Dispatch, Action } from 'redux';

export const ExerciseBaseRoute = '/exercise';
export const ExerciseRoute = `${ExerciseBaseRoute}/:id?`;

export interface IExercisePageProps {
  appLoaded: boolean;
  localeLoaded: boolean;
  view: EExerciseView;
  onOpen: (exerciseLink: string, workoutIndex?: number) => void;
}

export const renderSubPage = (view: EExerciseView) => {
  switch (view) {
    case EExerciseView.Intro:
      return <IntroPage />;
    case EExerciseView.Modes:
      return <ExtraModesPage />;
    case EExerciseView.Workout:
      return <WorkoutPage />;
    case EExerciseView.Evaluation:
      return <EvaluationPage />;
    case EExerciseView.FirstSessionFinished:
      return <PostFirstSessionPage />;
    case EExerciseView.Session:
      return <SessionPage />;
    case EExerciseView.Celebration:
      return <CelebrationPage />;
    case EExerciseView.NotImplemented:
      return <NotImplementedModePage />;
    case EExerciseView.ChallengeExerciseCompleted:
      return <ChallengeExerciseCompletedPage />;
    default:
      return null;
  }
};

interface ILocationType {
  index?: number;
}

export const ExercisePageView: React.FC<IExercisePageProps> = ({ appLoaded, localeLoaded, view, onOpen }) => {
  const { id } = useParams<{ id?: string }>();
  // we want to rerender the page whenever location change even if its only state that changes
  // location.key must change when we push new location to history even if location.pathname is same
  const location = useLocation<ILocationType | undefined>();
  const dispatch = useDispatch<Dispatch<Action<string>>>();
  React.useEffect(() => {
    if (appLoaded) {
      const exerciseLink = id ?? '';
      let workoutIndex: number | undefined = undefined;
      if (location.state) {
        workoutIndex = location.state.index;
      }
      onOpen(exerciseLink, workoutIndex);
      handlePathChange(dispatch);
    }
  }, [appLoaded, onOpen, id, location, dispatch]);
  if (!appLoaded || !localeLoaded) return <LoadingSpinner assetsUrl={ENV.AssetsBaseUrl} />;
  return renderSubPage(view);
};

export const mapStateToProps = (state: IState) => {
  const appLoaded = !AppSelectors.isAppLoading(state);
  const localeLoaded = !LanguageSelectors.isLoading(state);
  const view = Selectors.getPageView(state);
  return {
    appLoaded,
    localeLoaded,
    view,
  };
};

export const mapDispatchToProps = {
  onOpen: ExerciseActions.openExercise,
};

const Exercise = connect(mapStateToProps, mapDispatchToProps)(ExercisePageView);
export default Exercise;
